<template>
  <el-menu-item v-if="!item.children.length" :index="item.path">
    <template v-if="item.icon">
      <el-icon><component :is="resolveIcon(item.icon)" /></el-icon>
    </template>
    <span>{{ item.title }}</span>
  </el-menu-item>
  <el-sub-menu v-else :index="String(item.id)">
    <template #title>
      <span class="submenu-title">
        <template v-if="item.icon">
          <el-icon><component :is="resolveIcon(item.icon)" /></el-icon>
        </template>
        <span>{{ item.title }}</span>
      </span>
    </template>
    <MenuItem v-for="child in item.children" :key="child.id" :item="child" />
  </el-sub-menu>
</template>

<script setup>
import { defineProps, defineOptions } from 'vue'
import * as icons from '@element-plus/icons-vue'
defineOptions({ name: 'MenuItem' })

const props = defineProps({
  item: { type: Object, required: true }
})

const resolveIcon = (name) => {
  if (!name) return null
  const pascal = name.replace(/(^|[-_])(\w)/g, (_, __, c) => c.toUpperCase())
  return icons[name] || icons[pascal] || null
}
</script>

<style scoped>
.submenu-title {
  display: flex;
  align-items: center;
}
.submenu-title > span:not(:first-child) {
  margin-left: 4px;
}
</style>
